module.exports = __webpack_public_path__ + "static/img/4.001a265.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/2/sp/4.png
// module id = o3IE
// module chunks = 0